module.exports = __webpack_public_path__ + "img/flecha_abajo_activa.758a05fa.svg";